<template>
  <v-menu right offset-x content-class="secondary-nav" v-model="isMenuOpen">
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        class="secondary-nav__trigger"
        :class="{ active: isMenuOpen }"
      >
        <app-sidebar-link :link="moreLink" :hideTooltips="disabledTooltip" />
      </div>
    </template>

    <v-list>
      <v-list-item
        v-for="(link, idx) in secondaryNavigation"
        :key="idx"
        :to="link.path"
        exact
      >
        <v-list-item-icon>
          <icon-base
            :fontIcon="link.fontIcon"
            :icon="link.fontIcon ? link.icon : `sidebar/${link.icon}`"
          />
        </v-list-item-icon>
        <v-list-item-title class="pr-2">
          {{ link.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { secondaryNavigation } from '../sidebarLinks';

import AppSidebarLink from '@/components/layouts/sidebar/links/AppSidebarLink.vue';

export default {
  name: 'SecondaryNav',
  components: {
    AppSidebarLink,
  },
  props: {
    disabledTooltip: Boolean,
  },
  data() {
    return {
      isMenuOpen: false,
      moreLink: {
        text: 'More',
        icon: 'more',
        path: '/more',
        disabled: true,
      },
    };
  },
  computed: {
    ...mapGetters('users', ['currentUser', 'isAdmin']),
    ...mapState('customObjects', ['standaloneObjects']),

    hasStandaloneObjects() {
      return this.standaloneObjects && this.standaloneObjects.length > 0;
    },

    secondaryNavigation() {
      const userRole = this.currentUser?.role;

      return secondaryNavigation.filter((link) => {
        const {
          permission,
          permissions,
          roles = [],
          feature,
          requiresStandaloneObjects,
        } = link || {};

        // Single permission check (existing behavior)
        if (permission && !this.hasPermission(permission)) {
          return false;
        }

        // Multiple permissions check (OR condition - user needs ANY of the permissions)
        if (permissions?.length) {
          const hasAnyPermission = permissions.some((p) =>
            this.hasPermission(p)
          );
          if (!hasAnyPermission) {
            return false;
          }
        }

        if (feature && !this.isFeatureEnabled(feature)) {
          return false;
        }

        if (roles?.length && !roles.includes(userRole)) {
          return false;
        }

        if (requiresStandaloneObjects && !this.hasStandaloneObjects) {
          return false;
        }

        return true;
      });
    },
  },
  methods: {
    ...mapActions('customObjects', ['fetchStandaloneObjects']),
  },
  created() {
    if (this.isAdmin) {
      this.fetchStandaloneObjects();
    }
  },
};
</script>

<style lang="less">
.secondary-nav {
  z-index: 999 !important;
  .v-list-item {
    display: flex;
    align-items: center;
    color: var(--v-appMain-base) !important;
    font-weight: 600;
  }
  .v-list-item__icon {
    margin: 12px 0;
  }
}

.secondary-nav__trigger {
  &.active {
    background-color: var(--v-background-base);
    position: relative;
  }
}
</style>
